import { Helmet } from "react-helmet-async";
import { systemKeywords } from "~/common/constants/keywordSystem";

export const SystemHelmet = ({ slug, keySystem, defaultDesc, bannerImage }) => {
  const system = systemKeywords[keySystem];
  if (!system) return null;
  const { title, keywords } = system;

  return (
    <Helmet key={keySystem}>
      <title>{`${title} | ApeTech Solutions`}</title>
      <meta name="description" content={defaultDesc || title} />
      <meta name="keywords" content={keywords.join(", ")} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={defaultDesc || title} />
      <meta property="og:image" content={bannerImage || "/default-banner.jpg"} />
      <meta property="og:url" content={`https://apetechs.com/system/${keySystem}/${slug}`} />
      <link rel="canonical" href={`https://apetechs.com/system/${keySystem}/${slug}`} />
    </Helmet>   
  );
};
